import React, { Component, Fragment } from 'react'
import { observer, Provider } from 'mobx-react'
import Menu from './Menu/index'
import style from './style.module.less'

@observer
export default class extends Component {
  render() {
    const { store } = this.props
    return (
      <Provider store={store}>
        <Fragment>
          {this.props.store.menus.map((menu, i) => {
            return <Menu index={i} key={i} />
          })}
          <div className={style.addMenuBtn} onClick={store.addMenu}>
            +继续添加同价位套餐
          </div>
        </Fragment>
      </Provider>
    )
  }
}
